module.exports = __webpack_public_path__ + "static/media/blue-2.7bca717f.png";